import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { Tag } from '@instructure/ui-tag';
import { IconOutcomesLine } from '@instructure/ui-icons';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
var OutcomeTags = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeTags, _React$Component);
  var _super = _createSuper(OutcomeTags);
  function OutcomeTags() {
    var _this;
    _classCallCheck(this, OutcomeTags);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.inputRefs = [];
    _this.setRef = function (id, ref) {
      _this.inputRefs[id] = ref;
    };
    _this.focusInput = function (id) {
      return _this.inputRefs[id].focus();
    };
    return _this;
  }
  _createClass(OutcomeTags, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var outcomes = this.props.outcomes;
      if (oldProps.outcomes.length && !outcomes.length) {
        this.emptyResults.focus();
      }
    }
  }, {
    key: "getSortedOutcomes",
    value: function getSortedOutcomes() {
      var outcomes = this.props.outcomes;
      return outcomes.sort(function (a, b) {
        return a.title ? a.title.localeCompare(b.title) : -1;
      }).filter(function (outcome) {
        return outcome.decorator !== 'HIDE';
      });
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _this2 = this;
      var emptyText = this.props.emptyText;
      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        jsx("div", {
          css: this.props.styles.text,
          ref: function ref(_ref) {
            return _this2.emptyResults = _ref;
          },
          tabIndex: "-1"
        }, emptyText)
      );
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this3 = this;
      var deselectOutcomeIds = this.props.deselectOutcomeIds;
      var sortedOutcomes = this.getSortedOutcomes();
      return sortedOutcomes.map(function (o, index) {
        return jsx("div", {
          css: _this3.props.styles.text,
          key: o.id
        }, jsx(Tag, {
          key: o.id,
          elementRef: function elementRef(ref) {
            return _this3.setRef(o.id, ref);
          },
          text: jsx(AccessibleContent, {
            alt: "Remove ".concat(o.title)
          }, o.title),
          "data-automation": "outcomeTag__text",
          onClick: function onClick() {
            deselectOutcomeIds && deselectOutcomeIds([o.id]);
            var priorListItem = sortedOutcomes[index - 1];
            if (priorListItem) {
              _this3.focusInput(priorListItem.id);
            } else {
              var nextListItem = sortedOutcomes[index + 1];
              if (nextListItem) {
                _this3.focusInput(nextListItem.id);
              }
            }
          },
          dismissible: true
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var sortedOutcomes = this.getSortedOutcomes();
      return jsx("div", {
        css: this.props.styles.line,
        "data-automation": "outcomeTag__alignedOutcomes"
      }, jsx(Text, {
        size: "medium"
      }, jsx(IconOutcomesLine, null)), jsx("div", {
        css: this.props.styles.tags
      }, sortedOutcomes.length ? this.renderTags() : this.renderEmpty()));
    }
  }]);
  OutcomeTags.displayName = "OutcomeTags";
  return OutcomeTags;
}(React.Component), _class2.propTypes = {
  emptyText: PropTypes.string.isRequired,
  outcomes: PropTypes.array.isRequired,
  deselectOutcomeIds: PropTypes.func,
  styles: stylesShape
}, _class2.defaultProps = {
  deselectOutcomeIds: null
}, _class2)) || _class);
export { OutcomeTags as default };